<template>
  <div>
    <Navbar ref="navbarRef" :selectedOption="1" />
    <h4></h4>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">ViveSola</th>
          <th scope="col">LugControl</th>
          <th scope="col">LugParto</th>
          <th scope="col">Peso</th>
          <th scope="col">Talla</th>
          <th scope="col">Fpp</th>
          <th scope="col">Fum</th>
          <th scope="col">ConsejeriaAC</th>
          <th scope="col">AtencionFechaReg</th>
          <th scope="col">AnticonceptivoNombre</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="atenobst in datosPaginados" :key="atenobst.idAtenObst">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(atenobst.idAtenObst)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(atenobst.idAtenObst)" title="Editar">edit_square</i></td>
          <td>{{atenobst.viveSola}}</td>
          <td>{{atenobst.lugControl}}</td>
          <td>{{atenobst.lugParto}}</td>
          <td>{{atenobst.peso}}</td>
          <td>{{atenobst.talla}}</td>
          <td>{{getFormattedDate(atenobst.fpp, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(atenobst.fum, 'DD/MM/YYYY')}}</td>
          <td>{{atenobst.consejeriaAC}}</td>
          <td>{{getFormattedDate(atenobst.atencionFechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{atenobst.anticonceptivoNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteAtenObst(atenobst.idAtenObst)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idAtenObst" class="form-label">IdAtenObst</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idAtenObst" name="idAtenObst" v-model="datoAtenObst.idAtenObst" disabled>
                </div>
              </div>
            </div>
<!-- Botón Lista de Valores  Atencion -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idAtencion" class="form-label"> Atencion</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idAtencion" name="idAtencion" v-model="datoAtenObst.idAtencion">
                      <option v-for="atencion in atencions" :value="atencion.idAtencion" :key="atencion.idAtencion">
                        {{ atencion.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Atencion -->
<!-- Botón Lista de Valores  Anticonceptivo -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idAnticonceptivo" class="form-label"> Anticonceptivo</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idAnticonceptivo" name="idAnticonceptivo" v-model="datoAtenObst.idAnticonceptivo">
                      <option v-for="anticonceptivo in anticonceptivos" :value="anticonceptivo.idAnticonceptivo" :key="anticonceptivo.idAnticonceptivo">
                        {{ anticonceptivo.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Anticonceptivo -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="viveSola" class="form-label">ViveSola</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="viveSola" name="viveSola" v-model="datoAtenObst.viveSola" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="lugControl" class="form-label">LugControl</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="lugControl" name="lugControl" v-model="datoAtenObst.lugControl" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="lugParto" class="form-label">LugParto</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="lugParto" name="lugParto" v-model="datoAtenObst.lugParto" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="peso" class="form-label">Peso</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="peso" name="peso" v-model="datoAtenObst.peso" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="talla" class="form-label">Talla</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="talla" name="talla" v-model="datoAtenObst.talla" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fpp" class="form-label">Fpp</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fpp" name="fpp" v-model="datoAtenObst.fpp" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fum" class="form-label">Fum</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fum" name="fum" v-model="datoAtenObst.fum" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="consejeriaAC" class="form-label">ConsejeriaAC</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="consejeriaAC" name="consejeriaAC" v-model="datoAtenObst.consejeriaAC" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarAtenObst" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditAtenObst" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
    <Footer/>
  </div>
</template>
<script>
import Navbar from '../../components/Navbar.vue'
import Footer from '../../components/Footer.vue'
import { validarForm } from '../../modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js';
//import { format } from 'date-fns';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Navbar, Footer
  },
  data () {
    return {
      atenobsts : [],
      datoAtenObst : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      atencions: [],
      anticonceptivos: [],
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
/*
  computed: {
    formattedFechaReg() {
      const originalDate = new Date(this.datoAuto.fechaReg);
      return format(originalDate, 'dd/MM/yyyy');
    },
  },
*/

  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.$refs.navbarRef.toggleProcesos()
    this.$refs.navbarRef.toggleReportes()
    this.$refs.navbarRef.toggleParametros()
    this.$refs.navbarRef.toggleAyuda()
    this.fetchAtencions()
    this.fetchAnticonceptivos()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas(){
      return Math.ceil(this.atenobsts.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwatenobsts/nombre/'+this.nombreBusqueda).then(response=>{
          this.atenobsts=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.atenobsts.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwatenobsts').then(response=>{
      this.atenobsts=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.atenobsts.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'idAtencion'
        ,'idAnticonceptivo'
        ,'viveSola'
        ,'lugControl'
        ,'lugParto'
        ,'peso'
        ,'talla'
        ,'fpp'
        ,'fum'
        ,'consejeriaAC'
      ];
      const requiredFieldsText = [
        'idAtencion'
        ,'idAnticonceptivo'
        ,'viveSola'
        ,'lugControl'
        ,'lugParto'
        ,'peso'
        ,'talla'
        ,'fpp'
        ,'fum'
        ,'consejeriaAC'
      ];
      return validarForm(this.datoAtenObst, requiredFields, requiredFieldsText);
    },
    async guardarAtenObst(){
      if(this.validarForm() === 1){
        try {
          await api.post('/atenobsts', this.datoAtenObst)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "AtenObst creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditAtenObst(){
      if(this.validarForm() === 1){
        try {
          await api.post('/atenobsts', this.datoAtenObst)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "AtenObst creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoAtenObst={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idAtenObst){
      this.modalWindow = true
      if(idAtenObst != null){    
           api.get('/vwatenobsts/'+idAtenObst).then(resp=>{
          this.datoAtenObst = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
      this.btnCrear = false
      this.btnEditar= true
    },
    abrirEditar(idAtenObst){
      if(idAtenObst != null){
        this.$router.push('/atenobstmd/'+idAtenObst)
      }
    },
    async deleteAtenObst (idAtenObst) {
      try{
        await api.delete('/atenobsts/'+idAtenObst)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
    fetchAtencions() {
      fetch('http://localhost:8080/api/v1/atencions')
        .then(response => response.json())
        .then(data => {
          this.atencions = data;
        })
        .catch(error => {
          console.error('Error fetching atencions:', error);
        });
    },
    fetchAnticonceptivos() {
      fetch('http://localhost:8080/api/v1/anticonceptivos')
        .then(response => response.json())
        .then(data => {
          this.anticonceptivos = data;
        })
        .catch(error => {
          console.error('Error fetching anticonceptivos:', error);
        });
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
